export default function digPath<P extends PropertyKey[], O extends object>(
  path: DigPath<P, O>,
  data: O,
): [unknown, PropertyKey] {
  let curr: unknown = data;

  const lastKey = path[path.length - 1];

  for (let i = 0; i < path.length - 1; i++) {
    curr = curr[path[i]];

    if (curr === undefined) break;
  }

  return [curr, lastKey];
}
